import Image from "next/image";
import type { MutableRefObject } from "react";
import { cardBrandTypes } from "@/constant";
import { useSignUpModal } from "@/states/ui.state";
export const getCardBrandsLogo = (cardType?: string) => {
  switch (cardType) {
    case cardBrandTypes.VISA:
      return <Image src={"/dashboard-assets/payment_cards/visa-card.svg"} alt="visa card" width={40} height={22} />;
    case cardBrandTypes.MASTER_CARD:
      return <Image src={"/dashboard-assets/payment_cards/mastercard.svg"} alt="master card" width={40} height={22} />;
    case cardBrandTypes.MAESTRO:
      return <Image src={"/dashboard-assets/payment_cards/maestro.svg"} alt="maestro card" width={40} height={22} />;
    case cardBrandTypes.AMEX:
      return <Image src={"/dashboard-assets/payment_cards/amex.svg"} alt="american express card" width={40} height={22} />;
    case cardBrandTypes.CIRCUS:
      return <Image src={"/dashboard-assets/payment_cards/circus.svg"} alt="circus card" width={40} height={22} />;
    case cardBrandTypes.PAYPAL:
      return <Image src={"/dashboard-assets/payment_cards/paypal.svg"} alt="paypal card" width={40} height={22} />;
    default:
      return <Image src={"/dashboard-assets/payment_cards/unknown-card.svg"} alt="unknown card" width={40} height={22} />;
  }
};
export function scrollToTopWithInputFocus(inputRef: MutableRefObject<HTMLElement | null>) {
  const state = useSignUpModal.getState();
  if (state.isTriedDownload) {
    inputRef.current?.focus();
  }
}